import api from '../api';

export const sendEmail = async (payload) =>
  api.post('/cliente/email/enviar', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
